import { gql } from "@apollo/client";

export const GET_ARCHIVO_VISITA = gql`
    query archivoVisita($idArchivoVisita: Int!) {
        archivoVisita(idArchivoVisita: $idArchivoVisita) {
           valorEsperado{
                idArchivo
                titulo
                extension
                contentType
                archivo
            }
        }
    }
`;